export default __webpack_public_path__ + "static/media/ficon-1.b3c3e2b1.svg";